"use strict";

exports.__esModule = true;
exports.fragmentCallRequest = exports.user = exports.fragmentUser = exports.fragmentUserFields = undefined;

var _templateObject = _taggedTemplateLiteralLoose(["\n  query user(\n    $userId:ID!\n  ){\n    user(\n      id:$userId\n    ){\n      ...user\n    }\n  }\n\n  ", "\n"], ["\n  query user(\n    $userId:ID!\n  ){\n    user(\n      id:$userId\n    ){\n      ...user\n    }\n  }\n\n  ", "\n"]);

var _graphqlTag = require("graphql-tag");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
} // import {
//   CallJoinRoom,
//   // updateCallRequest,
// } from 'query';
// export {
//   CallJoinRoom,
//   // updateCallRequest,
// }


var fragmentUserFields = exports.fragmentUserFields = "\n  fragment userFields on User{\n    id\n    username\n  }\n";
var fragmentUser = exports.fragmentUser = "\n  fragment user on User{\n    ...userFields\n  }\n\n  " + fragmentUserFields + "\n";
var user = exports.user = (0, _graphqlTag2.default)(_templateObject, fragmentUser);
var fragmentCallRequest = exports.fragmentCallRequest = "\n  fragment callRequest on CallRequest{\n    id\n    Called{\n      ...userFields\n    }\n    Caller{\n      ...userFields\n    }\n    caller_descriptions\n    called_descriptions\n    status\n  }\n \n\n  " + fragmentUserFields + "\n\n";